import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { MyAccountPageRoutingModule } from './my-account-routing.module';

import { MyAccountPage } from './my-account.page';
import { SharedModule } from '../shared/shared.module';
import { ApiSettingsComponent } from '../api-settings/api-settings.component';
import { AddApiSettingComponent } from '../api-settings/add-api-setting/add-api-setting.component';
import { EditApiSettingComponent } from '../api-settings/edit-api-setting/edit-api-setting.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SharedModule,
    MyAccountPageRoutingModule,
  ],
  declarations: [
    MyAccountPage,
    ApiSettingsComponent,
    AddApiSettingComponent,
    EditApiSettingComponent
  ]
})
export class MyAccountPageModule {}
